import { EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Injectable({
  providedIn: 'root'
})
//can be used as common service for emr
export class OpprescriptionService {
  showAlert: boolean = true;
  mainBlocks: any = []
  val: any;
  brandConfig:any;
  accordianData: [];
  orderSetData: [];
  medication_data:any = [];
  clinical_data:any = [];
  allergyData:any = [];
  coMorbidityData:any = [];
  allergyDataByUhid:any=[]
  coMorbidityDataByUhid:any = [];
  sub = new Subject();
  coversheetStatus = this.sub.asObservable();
  selectall:boolean = true
  invokeAllData = new EventEmitter();
  invokeComponentFunction = new EventEmitter();
  clinicalPrice = new EventEmitter();
  invokeStoreFunction = new EventEmitter();
  invokeMedicationComponentFunction = new EventEmitter();
  invokeAdviceComponentFunction = new EventEmitter();
  invokeDiagnosis = new EventEmitter();
  subsVar: Subscription;
  subsVar_medication: Subscription;
  subsVar_advice: Subscription;
  subsVar_clinical: Subscription;
  subsVar_allData: Subscription;
  ClinicalCall;
  storeId;
  store;
  itemPriceCheckRequired: boolean = false;
  radioIntegration: boolean = false;
  duplicateOrderConfigValue: any;
  commonConfig: any = {};
  defaultStoreData: any;
  home_delivery:boolean = false;
  orderSetDataClinical: any;
  orderSetDataMedication: any;
  medicationValidation:any;
  clinicalValidation:any;
  priorityData:any;
  medicationSubscibe:any = true;
  clinicalSubscribe:any = true
  sameSaltValidationConfigValue: boolean = false;
  invokeStoreDisableStatus = new EventEmitter<boolean>();
  storeDisableSubs: Subscription;
  invokeCopyButtonClickedStatus = new EventEmitter<boolean>();
  copyButtonClickedSubs: Subscription;
  deptDiagnosisState: string = '';
  deptDiagnosisStateChange = new EventEmitter<string>();
  private dataSubject = new BehaviorSubject<any>(null);
  data$ = this.dataSubject.asObservable();

  constructor(
    public baseService: BaseService,
    public alerts: AlertsService,
    ) { }
  
  setDataChangeTemplate(data: any) {
    this.dataSubject.next(data);
  }

  setDeptDiagnosisState(state: string): void {
    this.deptDiagnosisState = state;
    this.deptDiagnosisStateChange.emit(state);
  }
  getDeptDiagnosisState(): string {
    return this.deptDiagnosisState;
  }
  updateCopyButtonClickedStatus(status: boolean) {
    this.invokeCopyButtonClickedStatus.emit(status);
  }
  updateStoreStatus(status: boolean) {
    this.invokeStoreDisableStatus.emit(status);
  }
  setVal(val) {
    this.val = val;
  }
  setAccordianData(data) {
    this.accordianData = data;
  }
  setbrandConfig(data) {
    this.brandConfig = data;
  }
  setMedicationData(data) {
    this.medication_data = data;
  }
  setClinicalData(data){
    this.clinical_data = data;
  }
  
  setAllData(val){
    this.invokeAllData.emit(val);
  }

  onInvestigation(val: boolean) {
    this.ClinicalCall = val;
    this.clinicalSubscribe = true
    this.invokeComponentFunction.emit(this.orderSetDataClinical);
  }

  InvestigationPrice(value){
    this.clinicalPrice.emit(value);
  }

  //this will set data for Advice Investigation Accordian
  setOrderSetData(data) {
    this.orderSetData = data;
  }
  //this will set do we have to show coversheet or not from the banner
  setcoversheet(val: boolean) {
    this.sub.next(val);
  }
  //this will be use for Advice Medication Order SET
  onMedication(val: boolean) {
    this.medicationSubscibe = true 
    this.invokeMedicationComponentFunction.emit(this.orderSetDataMedication);
  }
  onAdviceOrderSet(data){
    this.invokeAdviceComponentFunction.emit(data)
  }
  setStore(val:boolean){
    this.invokeStoreFunction.emit(val);
  }
  checkAssumedStock(args, event, cb) {
    if(event.itemCode!==undefined && (event.itemCode==="0"||event.itemCode===""||event.itemCode===0))
      {
      cb(true);
      return;
      }
    args += ",entitled:true";
    this.baseService.get('get_stock_by_pending_presc', args, 'medicationOrder', 'pharmacy').subscribe(data => {
      if (data.errCode == 0 && data.resource && data.resource.length > 0 && data.resource[0].showStock) {
        // this.mainObject.assumed_stock =  data.resource[0].assumed_stock;
        if (data.resource[0].assumed_stock <= 0) {
          this.alerts.error(`Stock for item ${event.itemName} is not available. You can't order this medicine`);
          cb(false);
        } else if (data.resource[0].assumed_stock > 0 && event.quantity && event.quantity > data.resource[0].assumed_stock ) {
          this.alerts.error(`Prescribed medicine quantity for ${event.itemName} is higher than stock. You can't order this medicine.`);
          cb(false);
        } else {
          cb(data.resource[0].assumed_stock);
        }
      } else if (data.errCode == 0 && data.resource && data.resource.length > 0 && !data.resource[0].showStock) {
        if (data.resource[0].assumed_stock <= 0) {
          this.alerts.error(`Stock for item ${event.itemName} is not available. You can't order this medicine`);
          cb(false);
        }
        if(data.resource[0].assumed_stock > 0 && event.quantity && event.quantity > data.resource[0].assumed_stock ) {
          this.alerts.error(`Prescribed medicine quantity for ${event.itemName} is higher than stock. You can't order this medicine.`);
        //console.log("reached here for stock qty limitaton")
         cb(false)
        }
        else{
        cb(true);
      }
      } else if (data.errCode == -1) {
        this.alerts.error(data.message);
        cb(false);
      }
    });
  }

  duplicateOrderConfig(){
    this.baseService.get('GET_CONFIG', "config_code:order-104,module_code:order", 'facility_config_mapping', 'facility-management').subscribe(data => {
      if(data && data.resource && data.resource.length>0){
          if(data.resource[0].config_value != "No"){
            this.duplicateOrderConfigValue = data.resource[0].config_value
          }
      }
    })
  }

  setServiceDate(element) {
    if (element.serviceType_code == 'pathology' || element.serviceType_code == 'neurology' || element.serviceType_code == 'radiology' || element.serviceType_code == 'pulmonology' || element.serviceType_code == 'cardiology' || element.serviceType_code == 'nuclear_medicine') {
      let date = new Date();
      return date.setHours(0, 0, 0, 0);
    } else {
      return new Date().getTime();
    }
  }

  getDosageFormDisabledConfig(){
    let args = "config_code:dosage_form_disabled,module_code:emr";
    this.baseService.get('GET_CONFIG', args, 'facility_config_mapping', 'facility-management').subscribe(res => {
        if (res && res.errCode == 0 && res.resource && res.resource.length > 0 && res.resource[0].config_value != undefined) {
            this.commonConfig.dosageFormDisabledConfig = res.resource[0].config_value == 'yes';
        } else {
            this.commonConfig.dosageFormDisabledConfig = false;
        }
    })
  }
  hideTariffConfigCall() {
    this.baseService.get('GET_CONFIG', "config_code:hide_tariff_button_info_icon,module_code:emr", 'facility_config_mapping', 'facility-management').subscribe({
      next: res => {
        if (res && res.resource && res.resource.length > 0) {
          this.commonConfig.hideTariffConfigValue = res.resource[0].config_value;
        }
      },
      error: err => console.error('hideTariffConfigCall failed', err)
    })
  }

  sameSaltValidationConfig(patientType) {
    this.baseService.get('GET_CONFIG', "config_code:same_active_generic,module_code:emr", 'facility_config_mapping', 'facility-management').subscribe(data => {
      if (data.errCode == 0 && data.resource.length > 0) {
        if (data.resource[0].multivalue != undefined && data.resource[0].multivalue != "" && data.resource[0].multivalue.length > 0) {
          let conf_val = data.resource[0].multivalue.find((d) => {
            return d.text == patientType;
          })
          if (conf_val == undefined)
            this.sameSaltValidationConfigValue = false;
          else
            this.sameSaltValidationConfigValue = true;
        } else {
          this.sameSaltValidationConfigValue = false;
        }
      } else {
        this.sameSaltValidationConfigValue = false;
      }
    })
  }

  sameSaltValidation(itemCode: any, patientType: string, uhId: string, encounter_id: string) {
    if (this.sameSaltValidationConfigValue) {
      if (Array.isArray(itemCode)) {
        if (itemCode.length == 1) {
          itemCode = itemCode[0]
        }
        else {
          itemCode = itemCode.join('#')
        }
      }
      let args = "patient_type:" + patientType + ",uhId:" + uhId + ",encounter_id:" + encounter_id + ",itemCode:" + itemCode;
      this.baseService.get("VALIDATE_SAME_SALT", args, "prescription_row", "emr").subscribe(res => {
        if (res.errCode == 0) {
          if (res.resource && Array.isArray(res.resource) && res.resource.length > 0) {
            res.resource.forEach((ele) => this.alerts.info(ele.alert_notification))
          }
        }
      })
    }
  }
  getPatientPregnantConfig() {
    if (this.commonConfig.patient_pregnant == undefined)
        this.baseService.get("GET_CONFIG", "module_code:emr,config_code:patient_pregnant", "facility_config_mapping", "facility-management").subscribe(data => {
            if (data.errCode == 0 && data.resource.length > 0) {
                if (data.resource[0].status == "active" && data.resource[0].multivalue != undefined && data.resource[0].multivalue != "" && data.resource[0].multivalue.length > 0){
                    data.resource[0].multivalue.find(e => {
                        if (e.id == "emr") {
                            this.commonConfig.patient_pregnant = true;
                        }
                    });
                    if(this.commonConfig.patient_pregnant)
                        this.baseService.get("GET_CONFIG", "module_code:emr,config_code:age_range_pregnant", "facility_config_mapping", "facility-management").subscribe(data => {
                            if (data.resource[0].config_value != undefined && data.resource[0].config_value != ""){
                                this.commonConfig.age_range_pregnant = data.resource[0].config_value;
                                let arr = this.commonConfig.age_range_pregnant.split('-');
                                this.commonConfig.age_range_pregnant1 = parseInt(arr[0]);
                                this.commonConfig.age_range_pregnant2 = parseInt(arr[1]);
                            }
                        });
                }else
                    this.commonConfig.patient_pregnant = false;
            } else {
                this.commonConfig.patient_pregnant = false;
            }
        });
  }

  getMedicationStoreCode(){
    let args = "config_code:SCM-245,module_code:inventory-management";
    this.baseService.get('GET_CONFIG', args, 'facility_config_mapping', 'facility-management').subscribe(res => {
        if (res.errCode == 0 && res.resource && res.resource.length > 0 && res.resource[0].config_value != undefined) {
            if (res.resource[0].config_value.includes('e-prescription'))
              this.commonConfig.zeroStockConfig = true;
        }
    })
  }
  grassFieldsMandatory(){
    let args = "config_code:Mand-Field,module_code:emr";
    this.baseService.get('GET_CONFIG', args, 'facility_config_mapping', 'facility-management').subscribe(res => {
        if (res.errCode == 0 && res.resource && res.resource.length > 0 && res.resource[0].config_value != undefined) {
            if (res.resource[0].config_value == 'yes'){
              this.commonConfig.refraction_fields_mandatory = true;
            }
        }
    })
  }

  duplicateOrderableDaysAlert() {
    this.baseService.get('GET_CONFIG', "config_code:DUPLICATE_ORDER_ALERT_FOR_ORDERABLE_DAYS,module_code:order", 'facility_config_mapping', 'facility-management').subscribe(res => {
      if (res.errCode == -1) {
        this.commonConfig['orderableDaysAlert'] = false;
      } else if (res.errCode == 0) {
        if (res && res.resource && res.resource.length > 0) {
          let data = res.resource[0];
          if (data && data.status == "active" && data.config_value == "yes")
            this.commonConfig['orderableDaysAlert'] = true;
          else
            this.commonConfig['orderableDaysAlert'] = false;
        }
      }
    })
  }

  sampleTypeConfigcall() {
    this.baseService.get('GET_CONFIG', "config_code:enable-sample-type,module_code:emr", 'facility_config_mapping', 'facility-management').subscribe(res => {
      if (res && res.resource && res.resource.length > 0) {
        if (res.resource[0].config_value.includes('OP')) {
          this.commonConfig.sampleTypeConfig = true
        }
      }
    })

  }
  isCIMSenabled(): { cims: boolean, dbName: string } {
    const isCimsEnabled = sessionStorage.getItem('YeK9fx4DQI') === 'true';
    const dbName = sessionStorage.getItem('YeK9fx4DQI_db') || 'kx_master';
  
    return {
      cims: isCimsEnabled,
      dbName: 'kx_master'//isCimsEnabled ? dbName : 'kx_master', // Ensures default dbName is applied if CIMS is not enabled
    };
  }
  iskxCimsMapping(): boolean {
    const isCimsConfigActive = sessionStorage.getItem('YeK9fx4DQI') === 'true';
    return !isCimsConfigActive && sessionStorage.getItem('KX_CIMS') === 'yes';
  }
  getAccountId()
 {
  let account_id=''
  let data=localStorage.getItem('CURRENT_ORGANIZATION')
  if(data)
  {
    let obj=JSON.parse(data)||{}
    if(obj?.account_id)
    {
     account_id=obj.account_id
    }
  }
  return account_id;
 }
checkBirthHistory(uhId:string): Promise<boolean> {
  return this.makeApiCheck('GET_BIRTH_HISTORY', 'uhId:' + uhId,'birth_history','emr','',"Birth History");
}
checkPastMedicalHistory(uhId:string,encounter_id:string): Promise<boolean> {
  let filter=`encounter_id:${encounter_id}`
  return this.makeApiCheck('GET_PASTMEDICALHISTORY_BY_UHID', 'uhId:' + uhId,'past_medical_history','emr',filter,"Past Medical History");
}


 checkPastSurgicalHistory(uhId:string,encounter_id:string):Promise<boolean> {
  let filter=`encounter_id:${encounter_id}`
  let args=`uhId:${uhId},secondary_uhid:true`
  return this.makeApiCheck('GET_PASTHISTORY_UHID', args,'past_surgical_history','emr',filter,"Past Surgical History");
}
checkGynecHistory(uhId:string,encounter_id:string):Promise<boolean>
 {
  let filter=`encounter_id:${encounter_id}`
  let account_id=this.getAccountId()
  let args=`uhId:${uhId},secondary_uhid:true,account_id:${account_id}`
  return this.makeApiCheck('GET_GYNECHISTORY_BY_UHID', args,'gynec_history','emr',filter,"Gynec History");
 }
 checkFamilyHistory(uhId:string,encounter_id:string):Promise<boolean>
 {
  let filter=`encounter_id:${encounter_id}`
  let account_id=this.getAccountId()
  let args=`uhId:${uhId},secondary_uhid:true,account_id:${account_id},encounter_id:${encounter_id}`
  return this.makeApiCheck('GET_FAMILYHISTORY_UHID', args,'family_history','emr',undefined,"Family History");
 }
 checkSocialHistory(uhId:string,encounter_id:string):Promise<boolean>
 {
  let filter=`encounter_id:${encounter_id}`
  let account_id=this.getAccountId()
  let args=`uhId:${uhId},secondary_uhid:true,account_id:${account_id}`
  return this.makeApiCheck('GET_SOCIALHISTORY_BY_UHID', args,'social_history','emr',filter,"Social History");
 }
 checkSexualHistory(uhId:string,encounter_id:string):Promise<boolean>
 {
  let filter=`encounter_id:${encounter_id}`
  let account_id=this.getAccountId()
  let args=`uhId:${uhId},secondary_uhid:true,account_id:${account_id}`
  return this.makeApiCheck('GET_SEXUALHISTORY_BY_UHID', args,'sexual_history','emr',filter,"Sexual History");
 }
 checkPsycoSocialHistory(uhId:string,encounter_id:string):Promise<boolean>
 {
  let filter=`encounter_id:${encounter_id}`
  let account_id=this.getAccountId()
  let args=`uhId:${uhId},secondary_uhid:true,account_id:${account_id}`
  return this.makeApiCheck('GET_PSYCHOSOCIALHISTORY_BY_UHID', args,'psychosocial_history','emr',filter,"PsycoSocial History");
 }
 checkTravelHistory(uhId:string,encounter_id:string):Promise<boolean>
 {
  let filter=`encounter_id:${encounter_id}`
  let account_id=this.getAccountId()
  let args=`uhId:${uhId},secondary_uhid:true,account_id:${account_id}`
  return this.makeApiCheck('GET_TRAVELHISTORY_BY_UHID', args,'travel_history','emr',filter,"Travel History");
 }
 checkMaritalHistory(uhId:string,encounter_id:string):Promise<boolean>
 {
  let filter=`encounter_id:${encounter_id},type:marital`
  let args=`uhId:${uhId},type:marital,encounter_id:${encounter_id}`
  return this.makeApiCheck('GET_PAGE', args,'marital_history','emr',filter,"Marital History");
 }
 checkPreviousFertilityHistory(uhId:string,encounter_id:string):Promise<boolean>
 {
  let filter=`encounter_id:${encounter_id},type:fertility`
  let args=`uhId:${uhId},type:fertility,encounter_id:${encounter_id}`
  return this.makeApiCheck('GET_PAGE', args,'marital_history','emr',filter,"Previous Fertility History");
 }
 checkImmunisationHistory(uhId:string,encounter_id:string):Promise<boolean>
 {
  let filter=`encounter_id:${encounter_id},uhId:${uhId},type:immunisation`
  return this.makeApiCheck('GET_PAGE','','familyMemberHistory','emr',filter,"Immunisation History");
 }
 private makeApiCheck(endpoint: string, args: string,resource:any,application:any,filter:any,type:any): Promise<boolean> {
  return new Promise((resolve) => {
    this.baseService.get(endpoint, args, resource, application,filter).subscribe({
      next: (result: any) => {
        if (result.errCode === 0 && result.resource?.length > 0) {
          resolve(true);
        } else {
          this.alerts.error(`please fill details of ${type} in History Segment`)
          resolve(false);
        }
      },
      error: () => resolve(false)
    });
  });
}
  getPrimaryPatientUhid() {
    const primaryDetails = JSON.parse(sessionStorage.getItem('primaryDetails') || '{}');
    return primaryDetails?.uhId || null;
  }

  //#195106
  checkDoctorOffSchedule(doctorId: string, doctorName: string, serviceType_code: string, bookingDateTime: number, serviceLabel?: string, itemKey?: string) {
    if (!doctorId || !serviceType_code || !bookingDateTime) {
      return;
    }
    let args = "doctor_id:" + doctorId + ",serviceType_code:" + serviceType_code + ",booking_date_time:" + bookingDateTime;
    this.baseService.get("CHECK_DOCTOR_OFF_SCHEDULE", args, "schedule_event_off", "facility-management").subscribe(res => {
      if (res?.resource?.length > 0 && res.resource[0].extra_data?.is_off_schedule) {
        this.alerts.info("The doctor " + (doctorName || '') + " is on off-schedule" + (serviceLabel ? " for " + serviceLabel : ''));
      }
    }, err => console.error('off-schedule check failed', err)); // alert only, a failed check must not surface to the user
  }
}
